import * as HoverCardPrimitive from '@radix-ui/react-hover-card';
import React__default from 'react';
import { Flex } from '../Flex/index.js';
import { HoverCardStyles } from './styles.js';
import { jsx } from '@emotion/react/jsx-runtime';
import { spacing } from '@hubble/tokens/web';

const HoverCardPortal = HoverCardPrimitive.Portal;
const HoverCardRoot = ({
  children,
  ...props
}) => jsx(HoverCardPrimitive.Root, {
  openDelay: 300,
  ...props,
  children: children
});
const HoverCardTrigger = React__default.forwardRef(({
  children,
  ...props
}, ref) => jsx(HoverCardPrimitive.Trigger, {
  asChild: true,
  ref: ref,
  ...props,
  children: children
}));
const HoverCardContent = React__default.forwardRef(({
  align = 'start',
  children,
  height,
  width,
  ...props
}, ref) => jsx(HoverCardPrimitive.Content, {
  ref: ref,
  align: align,
  asChild: true,
  sideOffset: 4,
  collisionPadding: 16,
  ...props,
  children: jsx(HoverCardStyles, {
    height: height,
    width: width,
    children: jsx(Flex, {
      flexDirection: "column",
      gap: spacing[4],
      children: children
    })
  })
}));
const HoverCard = Object.assign(HoverCardRoot, {
  Portal: HoverCardPortal,
  Trigger: HoverCardTrigger,
  Content: HoverCardContent,
  displayName: 'HoverCard'
});

export { HoverCard };
